import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Alert from '@glu/alerts-react';
import { ALERTVARIATIONS } from 'constants.js';
import AppPropTypes from 'proptypes/AppPropTypes';
import DuplicateAlert from './DuplicateAlert';

const MEMO = 'Memo';

const ActionAlert = ({
  classes,
  classes: {
    alertCol,
    alertDetails,
    alertHead,
    alertMemoCol,
    alertValue,
    message,
    messageExit,
    section
  },
  clearNotAllowed,
  clearPaymentActionMessage,
  duplicateDetails,
  duplicateMsg,
  locale,
  paymentActionMessage: {
    details,
    id,
    msg,
    success,
    title,
    titleExtra,
    warning: { hasWarning, warningCode, warningMessage } = {},
    hasDuplicatePayment,
    hasLimitWarning
  } = {}
}) => {
  const [display, setDisplay] = useState(true);
  let variant = ALERTVARIATIONS.ERROR;
  if (success) variant = ALERTVARIATIONS.SUCCESS;
  if (hasWarning || hasDuplicatePayment || hasLimitWarning) variant = ALERTVARIATIONS.WARNING;
  const showDetails = variant === ALERTVARIATIONS.SUCCESS && details?.length;
  return (
    <div className={display ? message : messageExit}>
      <Alert
        details={showDetails}
        title={title}
        variant={variant}
        onHide={() => {
          setDisplay(false);
          clearNotAllowed();
          setTimeout(() => clearPaymentActionMessage(id), 500);
        }}
        dataQa={`payments-action-alert-${variant}`}
      >
        {msg && <div>{msg}</div>}
        {details ? (
          <div className={section}>
            {warningCode && (
              <div className={alertCol}>
                <p>{warningMessage}</p>
              </div>
            )}
            {Array.isArray(details[0]) ? (
              details.map((detail) => (
                <section key={`alert-${detail.head}`} className={alertDetails}>
                  {detail.map((det) => (
                    <div className={alertCol} key={`details-${det.value}`}>
                      <div className={alertHead}>{det.head}</div>
                      <div className={alertValue}>{det.value}</div>
                    </div>
                  ))}
                </section>
              ))
            ) : (
              <section className={alertDetails}>
                {details.map((detail) => (
                  <div key={detail.head}>
                    <div
                      className={classnames(alertCol, detail.head === MEMO ? alertMemoCol : '')}
                      key={`details-${detail.head}`}
                    >
                      <div className={alertHead}>{detail.head}</div>
                      <div className={alertValue}>{detail.value}</div>
                    </div>
                  </div>
                ))}
              </section>
            )}
          </div>
        ) : (
          <div>{titleExtra && <div className={titleExtra}>{titleExtra()}</div>}</div>
        )}
        {duplicateMsg && (
          <DuplicateAlert
            duplicateMsg={duplicateMsg}
            duplicateDetails={duplicateDetails}
            classes={classes}
            locale={locale}
          />
        )}
      </Alert>
    </div>
  );
};

ActionAlert.propTypes = {
  classes: AppPropTypes.jssClasses.isRequired,
  clearNotAllowed: PropTypes.func,
  clearPaymentActionMessage: PropTypes.func,
  duplicateMsg: PropTypes.string,
  duplicateDetails: PropTypes.shape({}),
  paymentActionMessage: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    title: PropTypes.string,
    details: PropTypes.oneOfType([
      PropTypes.arrayOf(
        PropTypes.arrayOf(
          PropTypes.shape({
            head: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
          })
        )
      ),
      PropTypes.arrayOf(
        PropTypes.shape({
          head: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
        })
      )
    ]),
    msg: PropTypes.string,
    titleExtra: PropTypes.func,
    success: PropTypes.bool,
    warning: PropTypes.shape({
      hasWarning: PropTypes.bool,
      warningCode: PropTypes.string,
      warningMessage: PropTypes.string
    })
  }).isRequired
};

ActionAlert.defaultProps = {
  clearPaymentActionMessage() {},
  clearNotAllowed() {},
  duplicateMsg: '',
  duplicateDetails: {}
};

export default ActionAlert;
